import { liveModeCirclePaused, liveModeCirclePulse, liveModeCircleStatic, liveModeIndicator } from './styles.css';

interface Props {
  paused?: boolean;
}

export const LiveModeIndicator: React.FC<Props> = ({ paused = false }) => (
  <div className={liveModeIndicator}>
    {paused ? (
      <div className={liveModeCirclePaused}></div>
    ) : (
      <>
        <div className={liveModeCircleStatic}></div>
        <div className={liveModeCirclePulse}></div>
      </>
    )}
  </div>
);
